export const palette = {
  primary: {
    main: '#1976D2',
    dark: '#1565C0',
    light: 'rgba(25, 118, 210, 0.3)',
  },
  secondary: {
    main: 'rgba(0,0,0, 0.54)',
    dark: '#7B1FA2',
  },
  error: {
    main: '#D32F2F',
    light: '#EF5350',
  },
  success: {
    main: '#2E7D32',
    light: '#4CAF50',
  },
  warning: {
    main: '#ED6C02',
    light: '#FF9800',
  },
  background: {
    default: '#ffffff',
  },
  text: {
    primary: 'rgba(0, 0, 0, 0.87)',
    secondary: 'rgba(0, 0, 0, 0.6)',
    disabled: 'rgba(0, 0, 0, 0.38)',
  },
  divider: 'rgba(0, 0, 0, 0.08)',
  header: {
    green: '#0F9244',
    black: '#191D29',
  },
  tableHead: '#FAFAFA',
};
